if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const form = document.querySelector("#bss-b2b-registration-form");
        const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
                if (item.target.id === "state-field") {
                  document.querySelector("#state-field").selectedIndex = -1;
                }
            }
        })
        observer.observe(form, {
            childList: true,
            subtree: true
        })
    }, 300)

    const interval = setInterval(() => {
    const title = document.querySelector('.bss-b2b-registration-form-title h1');

    if (title) {
      clearInterval(interval); 

      const selectEls = document.querySelectorAll(
        '.bss-b2b-rf-field:has(label[title="Your SalonX Rep?"]) select, .bss-b2b-rf-field:has(label[title="Free Sample?"]) select'
      );

      if (selectEls.length > 0) {
        selectEls.forEach((select) => {
          const option = document.createElement("option");
          option.value = "";
          option.textContent = "Please select...";
          option.disabled = true;
          option.selected = true;

          select.insertBefore(option, select.firstChild);
        });
      }
    }
  }, 300); 

  setTimeout(() => {
    clearInterval(interval)
  },  8000);

}